export const shouldRenderPreview = (
  url: string | null | undefined
): boolean => {
  if (!url) return false;
  const match = url.match(/^https/i);
  if (!match) {
    return false;
  }
  return match.length > 0;
};
